import { render, staticRenderFns } from "./UsersReportComponent.vue?vue&type=template&id=64582146&scoped=true"
import script from "./UsersReportComponent.vue?vue&type=script&lang=js"
export * from "./UsersReportComponent.vue?vue&type=script&lang=js"
import style0 from "./UsersReportComponent.vue?vue&type=style&index=0&id=64582146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64582146",
  null
  
)

export default component.exports